'use client';

import React, { useState } from 'react';
import PaymentMethodsList from '@/app/[locale]/(account)/account/components/payment-methods-list';
import PaymentMethodsLayout from '@/components/common/payment-mehods-layout';
import { PAYMENT_TYPES } from '@/constants';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';
import DepositPaymentMethodDetails from './deposit-payment-method-details';

export type ViewType = 'CRYPTO_DETAILS' | 'OTHER_COINS' | 'FIAT' | 'CREDIT_CARDS' | null;

type DepositProps = {
  isQuickDeposit?: boolean;
  selectedView?: ViewType;
  selectedMethod?: FullMethod;
};

const Deposit = ({ isQuickDeposit, selectedView = 'CRYPTO_DETAILS', selectedMethod }: DepositProps) => {
  const [view, setView] = useState<ViewType>(selectedView);
  const [method, setMethod] = useState<FullMethod | undefined>(selectedMethod);

  return (
    <PaymentMethodsLayout
      paymentType={PAYMENT_TYPES.DEPOSITS}
      view={view}
      setView={setView}
      selectedMethod={method}
      setSelectedMethod={setMethod}
      isQuickDeposit={isQuickDeposit}
      leftSideRenderer={() => (
        <PaymentMethodsList
          paymentType={PAYMENT_TYPES.DEPOSITS}
          view={view}
          setView={setView}
          selectedMethod={method}
          setSelectedMethod={setMethod}
          isQuickDeposit={isQuickDeposit}
        />
      )}
      rightSideRenderer={() => (
        <DepositPaymentMethodDetails
          view={view}
          setView={setView}
          selectedMethod={method}
          setSelectedMethod={setMethod}
        />
      )}
    />
  );
};

export default Deposit;
